import React from "react";

export const utf8Icons = [
    <div>🦜</div>,<div>🦚</div>, <div>🦉</div>, <div>🦆</div>,
    <div>🦅</div>,<div>🦘</div>, <div>🐨</div>,<div>🦔</div>,
    <div>🐇</div>, <div>🐘</div>,<div>🦙</div>, <div>🐫</div>,
    <div>🐑</div>, <div>🐖</div>,<div>🐎</div>, <div>🐆</div>
]

export const availableCardStatuses = {
    clicked: 'X',
    discovered: 'D',
    hole: ''
}
